import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import TemplateDetails from '../components/template-details';
import getLocale from '../modules/i18n/selectors/locale';
import user from '../modules/user';
import useTemplateBySlug from '../modules/templates/hooks/use-template-by-slug';
import routesMap from '../router/helpers/routes-map';
import { SiteSetupContext } from '../modules/site-setup/helpers/site-setup-context';
import getSiteIdToSwitch from '../modules/sites/selectors/site-id-to-switch-template';

const TemplateDetailsContainer = () => {
  const navigate = useNavigate();
  const params = useParams();
  const { templateSlug } = params;

  const context = useContext(SiteSetupContext);
  const archetype = context.getArchetype();
  const isArchetypeSet = archetype !== undefined;

  const locale = useSelector(getLocale);
  const siteIdToSwitch = useSelector(getSiteIdToSwitch);
  const isUserAuthorized = user.verifiers.isUserAuthorized();

  const { template: selectedTemplate, attemptedSingleFetch } = useTemplateBySlug(
    templateSlug,
    locale
  );

  if (isUserAuthorized && !templateSlug && !isArchetypeSet && !siteIdToSwitch) {
    navigate(routesMap.siteCategory.url(), { replace: true });
    return null;
  }

  if (attemptedSingleFetch && !selectedTemplate) {
    navigate(routesMap.gallery.url(), { replace: true });
    return null;
  }

  if (!selectedTemplate) {
    return null;
  }

  return (
    <>
      <TemplateDetails name={templateSlug} livePreviewUrl={selectedTemplate.livePreviewUrl} />
      <Outlet />
    </>
  );
};

export default TemplateDetailsContainer;
